<shared-badge
  *ngIf="type"
  [class]="classes"
  [label]="label"
  [tooltip]="tooltip"
>
</shared-badge>
